<script setup>
  import { computed } from 'vue'

  import { getEnv } from '@/features/versioning/getEnv.js'
  import { getVersion } from '@/features/versioning/getVersion.js'

  const version = getVersion()
  const env = getEnv()

  const versionText = computed(() => {
    return `v${version.version}`
  })

  const isProd = env === 'prod'
</script>

<template>
  <div
    class="version-text"
    :data-version="version.version"
    :data-env="env"
    :data-build-date="version.buildDate"
    :data-commit-hash="version.commitHash"
    :data-branch="version.branch"
  >
    {{ versionText }} {{ isProd ? '' : `(${env})` }}
  </div>
</template>

<style lang="scss" scoped>
  .version-text {
    font-size: 12px;
    color: light-dark(#999, #999);
    text-align: center;
  }
</style>
